import React from 'react';

export const PDF = () => {
  return (
    <svg
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      viewBox="0 0 600 600"
      width={24}
      height={24}
    >
      {/* <!-- Generator: Adobe Illustrator 29.4.0, SVG Export Plug-In . SVG Version: 2.1.0 Build 152)  --> */}
      <g>
        <g>
          <path
            className="st0"
            fill="#fff"
            d="M377.22,344.18v51.39h36.87c7.34,0,14.05,3.5,17.22,9.01,3.17,5.5,2.23,12.04-2.4,16.77h-.05,0l-108.34,110.86c-3.63,3.7-9.06,5.85-14.81,5.85s-11.2-2.15-14.82-5.85l-108.34-110.86c-4.63-4.73-5.57-11.27-2.4-16.77s9.86-9.01,17.22-9.01h36.87v-51.39"
          />
          <path
            className="st0"
            fill="#fff"
            d="M232.11,105.4V33.1c0-8.74,8.53-15.83,19.07-15.83h104.82c10.55,0,19.07,7.09,19.07,15.83v72.31"
          />
        </g>
        <path
          className="st0"
          fill="#fff"
          d="M129.6,487.41v87.06c0,5.97,5.06,11.04,11.04,11.04h279.48c12.87,0,25.84.48,38.69,0,.18,0,.36,0,.54,0,5.97,0,11.04-5.06,11.04-11.04v-87.06c0-14.21-22.09-14.24-22.09,0v87.06c3.68-3.68,7.36-7.36,11.04-11.04H179.88c-12.77,0-25.95-.96-38.69,0-.18.01-.36,0-.54,0,3.68,3.68,7.36,7.36,11.04,11.04v-87.06c0-14.21-22.09-14.24-22.09,0h0Z"
        />
      </g>
      <g>
        <path
          className="st0"
          fill="#fff"
          d="M158.63,243.9h-31.62v53.74c0,7.68-1.64,13.5-4.89,17.48s-7.37,5.96-12.32,5.96-9.38-1.97-12.55-5.9c-3.19-3.93-4.76-9.69-4.76-17.29v-146.32c0-8.45,1.74-14.5,5.24-18.12s9.03-5.45,16.63-5.45h44.29c13.09,0,23.17,1.12,30.23,3.38,6.98,2.15,13,5.74,18.08,10.75,5.07,5.01,8.92,11.14,11.58,18.39,2.63,7.25,3.96,15.41,3.96,24.48,0,19.34-5.34,33.98-16.05,43.96-10.69,9.96-26.63,14.95-47.77,14.95h-.04ZM150.26,156.89h-23.25v58h23.25c8.14,0,14.93-.95,20.4-2.86,5.47-1.91,9.63-5.01,12.49-9.32,2.86-4.31,4.31-9.96,4.31-16.96,0-8.37-2.22-15.2-6.63-20.46-4.97-5.61-15.16-8.41-30.56-8.41Z"
        />
        <path
          className="st0"
          fill="#fff"
          d="M253.62,128.02h45c11.7,0,21.74,1.2,30.11,3.62,8.37,2.42,15.97,6.96,22.78,13.6,17.75,16.92,26.63,42.64,26.63,77.18,0,11.39-.89,21.8-2.67,31.21-1.78,9.4-4.53,17.89-8.26,25.45-3.73,7.56-8.49,14.31-14.29,20.27-4.58,4.58-9.57,8.24-14.99,11.02-5.43,2.75-11.26,4.7-17.5,5.82-6.23,1.12-13.27,1.68-21.1,1.68h-44.98c-6.27,0-11-1.06-14.18-3.17-3.19-2.11-5.26-5.09-6.21-8.92-.97-3.83-1.45-8.82-1.45-14.95v-139.2c0-8.28,1.66-14.29,4.99-17.99s8.72-5.57,16.15-5.57l-.02-.04ZM266.99,158.44v128.84h26.15c5.74,0,10.23-.17,13.48-.52,3.25-.35,6.63-1.2,10.11-2.59,3.48-1.39,6.5-3.31,9.07-5.82,11.55-10.87,17.31-29.61,17.31-56.2,0-18.74-2.55-32.76-7.62-42.08-5.07-9.32-11.33-15.26-18.78-17.81-7.43-2.55-16.42-3.81-26.96-3.81h-22.78l.02-.02Z"
        />
        <path
          className="st0"
          fill="#fff"
          d="M491.23,157.67h-68v48.56h56.84c5.26,0,9.19,1.33,11.8,3.96,2.59,2.63,3.89,6.15,3.89,10.56s-1.33,7.89-3.96,10.48c-2.63,2.59-6.54,3.89-11.74,3.89h-56.84v62.54c0,7.95-1.62,13.83-4.82,17.68-3.21,3.83-7.35,5.76-12.38,5.76s-9.28-1.95-12.49-5.82c-3.21-3.89-4.82-9.75-4.82-17.6v-146.05c0-5.53.75-10.04,2.22-13.52,1.47-3.5,3.77-6.05,6.92-7.64s7.14-2.4,12.03-2.4h81.36c5.51,0,9.59,1.37,12.26,4.08,2.67,2.71,4.02,6.27,4.02,10.69s-1.35,8.1-4.02,10.81c-2.67,2.71-6.77,4.08-12.26,4.08v-.04Z"
        />
      </g>
    </svg>
  );
};
